import React from 'react'
import { Row, Col, Form, Modal, Button } from 'react-bootstrap'

class ZoomRedirectPopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: this.props.show
    }
  }

  render() {
    const datapulsePreview = require("images/datapulse-tablet-preview.png");
    const datapulseLogo = require("images/logos/datapulse-logo-blue-small.png");
    return (
      <>
        <Modal className="zoom-redirect-modal" show={this.state.show} onHide={(e) => this.setState({show: false})}>
          <div>
            <div className="grey-circle"></div>
            <div className="blue-circle"></div>
            <Modal.Header closeButton>
              <Modal.Title>Zoom has evolved...</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="pb-5">
                <Col className="text-center">
                  <h5>Introducing</h5>
                  <img src={`/datapulse${datapulseLogo}`} style={{maxWidth: "375px"}} />
                </Col>
              </Row>
              <Row className="pb-5">
                <Col sm={7}>
                  <p className="py-4" style={{maxWidth: "400px", lineHeight: "22px"}}>Due to the emergence of Zoom (the communication software that exploded in popularity in 2020), we have since rebranded our Zoom to be called "DataPulse". Not only did it get a new name, but also a new look, and tons of exciting features in the works!</p>
                </Col>
                <Col sm={5}>
                  <img src={`/datapulse${datapulsePreview}`} className="w-100" />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Row className="text-center">
                <Col>
                  <p className="mb-1" style={{fontSize: "14px"}}><b>You can still login using your old Zoom credentials.</b></p>
                  <Button variant="info" onClick={(e) => this.setState({show: false})}>
                    Continue to DataPulse >
                  </Button>
                </Col>
              </Row>
            </Modal.Footer>
          </div>
        </Modal>
      </>
    );
  }

}

export default ZoomRedirectPopup;
